import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import LocationService from "services/LocationService";

export const getLocations = createAsyncThunk(
  "location/getLocations",
  async (params, { rejectWithValue }) => {
    try {
      const response = await LocationService.getLocations(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addLocation = createAsyncThunk(
  "location/addLocation",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await LocationService.addLocation(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add location"
      );
    }
  }
);

export const editLocation = createAsyncThunk(
  "location/editLocation",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await LocationService.updateLocation(params, data);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editLocationStatus = createAsyncThunk(
  "location/editLocationStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await LocationService.statusUpdateLocation(data, status);
      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadLocationExcel = createAsyncThunk(
  "location/downloadLocationExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await LocationService.downalodLocationExcel(
        data,
        params
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleLocation = createAsyncThunk(
  "location/getSingleLocation",
  async (params, { rejectWithValue }) => {
    try {
      const response = await LocationService.getSingleLocation(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const locationSlice = createSlice({
  name: "locations",
  initialState: {
    locations: {},
    singleLocation: {},
    excelLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(getLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadLocationExcel.pending, (state) => {
        state.excelLoading = true;
        state.error = null;
      })
      .addCase(downloadLocationExcel.fulfilled, (state, action) => {
        state.excelLoading = false;
        // state.locationEscel = action.payload;
      })
      .addCase(downloadLocationExcel.rejected, (state, action) => {
        state.excelLoading = false;
        state.error = action.payload;
      })
      .addCase(getSingleLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.singleLocation = action.payload;
      })
      .addCase(getSingleLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addLocation.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editLocation.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editLocationStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editLocationStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editLocationStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = locationSlice.actions;
export default locationSlice.reducer;
